import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { openInstantSaleCheckout } from 'utilities/open-instant-sale-checkout';

export const shouldShowStandaloneChargeButton = () =>
  Boolean(App.config.get('venue').pointOfSaleEnabled) &&
  Wahanda.Features.isEnabled('pay-standalone-terminal') &&
  Wahanda.Features.isEnabled('TEF-2035-new-checkout-flow');

export const openStandaloneTerminalCharge = () => {
  const openCheckout = () => openInstantSaleCheckout({ isStandaloneTerminal: true });

  Wahanda.Cache.posStatus().done((status) => {
    if (!Wahanda.POSCheckoutCheck(status, openCheckout)) {
      return;
    }
    openCheckout();
  });
};
